import React, { useState, useEffect} from 'react'
import { Link, useNavigate } from "react-router-dom"
import { addBettingPhoto } from '../../redux/slice/bettingSlice/bettingPhoto'
import { addBettingOrder } from '../../redux/slice/bettingSlice/bettingSlice'
import { postBettingTransaction } from '../../utils/processTransactions/processBetting/processBettingTransaction'
import { useAppSelector, useAppDispatch } from "../../utils/TypeScript"
import Spinner from '../Alert/Spinner/Spinner'


const BettingDoneComp = () => {

    const [loading, setLoading] =useState(false)
    const [success, setSuccess] =useState(false)

    const dispatch = useAppDispatch()
    const navigate = useNavigate()


    const { currentBettingPhoto } = useAppSelector(state => state.bettingPhoto)
    const { currentBettingOrder } = useAppSelector(state => state.betting)
    

    const redirectToHome = () =>{
        setTimeout(()=>{
            localStorage.clear();
            navigate("/")
        }, 50000)
    }

    const postTransaction = async () =>{
        setLoading(true)

        if(currentBettingOrder !== undefined) {
            const transactionResponse = await postBettingTransaction(currentBettingOrder)
            const {  responseMessage } = transactionResponse
            // console.log(transactionResponse);

            if(responseMessage.toLowerCase() === "successful" ){
                setSuccess(true) 
                setLoading(false)
                localStorage.clear();
                redirectToHome()

            }else{
                localStorage.clear();
                redirectToHome()
                return setLoading(false)
            }

 
        }
    }
  
   

    const getFromLocalStorage = async ()=>{
        setLoading(true)

        const bettingPhoto =  JSON.parse(localStorage.getItem('bettingPhoto') || "{}");
        const bettingOrder =  JSON.parse(localStorage.getItem('bettingOrder') || "{}");
       

        dispatch(addBettingPhoto(bettingPhoto))
        dispatch(addBettingOrder(bettingOrder))
       

    }


    useEffect(()=>{
        if(localStorage.getItem('bettingPhoto') === null ) return navigate("/")

        getFromLocalStorage()
    }, [ ])
    
    useEffect(()=>{
        // if(localStorage.getItem('bettingPhoto') === null ) return navigate("/")
        if(localStorage.getItem('payment') === null ) return navigate("/")

        const payment =  localStorage.getItem('payment') || " ";
        if(payment !== "i") return setLoading(false)
           
        postTransaction()
    }, [currentBettingOrder])




  return (
    <div className="col-lg-9">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="bg-light shadow-sm text-center mb-3">
                                <div className="d-flex admin-heading pr-3">
                                    <div className="mr-auto">
                                    <h4 className="text-9 font-weight-400" style={{color: "#3f0d5e"}}><i className="fas fa-wallet mr-2"></i>
                                    {
                                        currentBettingPhoto?.billerCode === 'BET9JA' ? "BET9JA"
                                        : 
                                        currentBettingPhoto?.billerCode === 'MYLOTTOHUB' ? "MYLOTTOHUB"
                                        : 
                                        currentBettingPhoto?.billerCode === 'MELBET' ? "MELBET"
                                        : 
                                        currentBettingPhoto?.billerCode === 'PARIPESA' ? 'PARIPESA'
                                        :
                                        currentBettingPhoto?.billerCode === 'BANGBET' ? "BANGBET"
                                        :
                                        currentBettingPhoto?.billerCode === 'BETKING' ? "BETKING"
                                        :
                                        currentBettingPhoto?.billerCode === 'NAIRAMILLION' ? "NAIRAMILLION"
                                        :
                                        currentBettingPhoto?.billerCode === 'CLOUDBET' ? "CLOUDBET"
                                        :
                                        currentBettingPhoto?.billerCode === 'ONE_XBET' ? "ONE_XBET"
                                        :
                                        currentBettingPhoto?.billerCode === 'NAIJABET' ? "NAIJABET"
                                        :
                                        currentBettingPhoto?.billerCode === 'BETLION' ? "BETLION"
                                        :
                                        ""
                                    }
                                
                                    </h4>
                                    </div>
                                    <div className="ml-auto">
                                    <h4 className="text-9 font-weight-400" style={{color: "#3f0d5e"}}>₦
                                    {
                                        currentBettingOrder?.details?.amount
                                    }
                                    </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-12 profile-content ">
                        <ul className="nav nav-pills">
                
                            <li className="nav-item">
                                <Link className="nav-link" to="">Order</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="">Summary</Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link className="nav-link" to="/recharge-payment">Payment</Link>
                            </li> */}
                            <li className="nav-item">
                                <Link className="nav-link active" to="" >Done</Link>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="five" role="tabpanel" aria-labelledby="five-tab">
                                
                                {
                                    loading ? 

                                        ""
                                    :
                                
                                
                                        <div className="done my-5">
                                            <h3 className="title">
                                                {
                                                    success ? 
                                                        "Transaction Successful"
                                                    :
                                                        "Transaction Failed"
                                                }
                                            </h3>

                                            <span className={`text-5 d-block  mt-4 mb-3 ${success? "text-success" : "text-danger"}`}>
                                                {
                                                    success ? 
                                                        <i className="fas fa-check-circle"></i>
                                                    :
                                                        <i className="fas fa-times-circle"></i>
                                                }
                                            </span>

                                            

                                            <p> <span>Your </span>
                                            
                                                    {
                                                        currentBettingPhoto?.billerCode === 'BET9JA' ? "BET9JA"
                                                        : 
                                                        currentBettingPhoto?.billerCode === 'MYLOTTOHUB' ? "MYLOTTOHUB"
                                                        : 
                                                        currentBettingPhoto?.billerCode === 'MELBET' ? "MELBET"
                                                        : 
                                                        currentBettingPhoto?.billerCode === 'PARIPESA' ? 'PARIPESA'
                                                        :
                                                        currentBettingPhoto?.billerCode === 'BANGBET' ? "BANGBET"
                                                        :
                                                        currentBettingPhoto?.billerCode === 'BETKING' ? "BETKING"
                                                        :
                                                        currentBettingPhoto?.billerCode === 'NAIRAMILLION' ? "NAIRAMILLION"
                                                        :
                                                        currentBettingPhoto?.billerCode === 'CLOUDBET' ? "CLOUDBET"
                                                        :
                                                        currentBettingPhoto?.billerCode === 'ONE_XBET' ? "ONE_XBET"
                                                        :
                                                        currentBettingPhoto?.billerCode === 'NAIJABET' ? "NAIJABET"
                                                        :
                                                        currentBettingPhoto?.billerCode === 'BETLION' ? "BETLION"
                                                        :
                                                        ""
                                                    }

                                                <span> TopUp of ₦</span>
                                                    {
                                                        currentBettingOrder?.details?.amount
                                                    } 
                                                <br/>
                                                to <b>
                                                    {
                                                        currentBettingOrder?.details?.accountNumber
                                                    } 
                                                </b>
                                                <span> {success ? "was successful" : "failed"}.</span>
                                                
                                                {success ? " Thank you for using PreponeBills" : " Please try again."}
                                            </p>

                                            
                                        </div>

                                }


                            </div>
                        </div>
                    </div>
                    { loading && <Spinner /> }
                </div>
  )
}

export default BettingDoneComp